import React from 'react';

const SmsConsentCheckbox = ({ checked, onChange }) => {
  return (
    <div className="flex items-start gap-3">
      <div className="flex items-center" style={{ minHeight: '44px' }}>
        <input
          id="sms-consent"
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="w-5 h-5 rounded border-2 border-gray-300 text-emerald-600 focus:ring-emerald-500 focus:ring-2 cursor-pointer"
        />
      </div>
      <label
        htmlFor="sms-consent"
        className="text-sm text-gray-700 cursor-pointer leading-relaxed"
        style={{ minHeight: '44px' }}
      >
        I consent to receive SMS messages from OutdoorGuides, including booking
        confirmations, trip coordination updates, account security codes, and
        payment notifications. Message frequency varies by booking activity.
        Msg &amp; data rates may apply. Reply STOP to opt out.{' '}
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-600 hover:text-emerald-700 underline"
        >
          Terms
        </a>{' '}
        &amp;{' '}
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-600 hover:text-emerald-700 underline"
        >
          Privacy Policy
        </a>
        .
      </label>
    </div>
  );
};

export default SmsConsentCheckbox;
